export enum EventVersionList {
  WEDDINGAPP = 'WeddingApp.1',
  WEDDINGAPPv0 = 'WeddingApp',
  MIRRORWEDDINGAPP = 'MirrorWedding',
}
